<div class="landing-container">
  <div class="login-container">
    <img src="assets/images/dwp-login.jpg"  class="login-dwp"/>
    <div class="title">
      {{ getLoginTitle() }}
    </div>
    <div class="form-container">
      <button (click)="loginUser()">{{'' | i18n: 'login'}}</button>
    </div>
  </div>

</div>
